module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chatroom"
  }, [_c('section', {
    staticClass: "hero is-fullheight is-light sui-messages"
  }, [_c('div', {
    staticClass: "hero-head sui-chat-header"
  }, [_c('bar', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "bar-content",
    slot: "left"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/64x64",
      "alt": "social-ui"
    }
  }), _vm._v(" social-ui\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "bar-content",
    slot: "center"
  }, [_c('div', {
    staticClass: "nav-item"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n              " + _vm._s(_vm.chatRoom.title) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-content",
    slot: "right"
  }, [_c('div', {
    staticClass: "nav-item is-pulled-right"
  }, [_c('button', {
    staticClass: "button is-white",
    on: {
      "click": function($event) {
        _vm.openModal()
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.countMessages === 0) ? _c('div', {
    staticClass: "columns"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._l((_vm.chatRoom.messages), function(message) {
    return [_c('article', {
      staticClass: "media"
    }, [_c('figure', {
      staticClass: "media-left"
    }, [(!message.person.isMe) ? _c('p', {
      staticClass: "image is-64x64 sui-avatar"
    }, [_c('img', {
      attrs: {
        "src": message.person.avatarUrl
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content box"
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(message.person.name))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(message.person.handle))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.timeAgoFromTimestamp(message.timestamp)))]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(message.content) + "\n                    ")])])]), _vm._v(" "), _c('div', {
      staticClass: "media-right"
    }, [(message.person.isMe) ? _c('p', {
      staticClass: "image is-64x64 sui-avatar"
    }, [_c('img', {
      attrs: {
        "src": message.person.avatarUrl
      }
    })]) : _vm._e()])])]
  })], 2)]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "hero-foot sui-chat-footer"
  }, [_c('div', {
    staticClass: "sui-chat-footer-form"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "field is-grouped is-horizontal"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputMessage),
      expression: "inputMessage"
    }],
    staticClass: "textarea",
    attrs: {
      "type": "text",
      "placeholder": "Type a message"
    },
    domProps: {
      "value": (_vm.inputMessage)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.sendMessage(_vm.inputMessage)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputMessage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-medium",
    class: _vm.sendMessageClass,
    on: {
      "click": function($event) {
        _vm.sendMessage(_vm.inputMessage)
      }
    }
  }, [_vm._m(3)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: _vm.modalClass
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h3', {
    staticClass: "title is-5"
  }, [_vm._v("\n              Participants\n            ")]), _vm._v(" "), _c('p', [_vm._l((_vm.chatRoom.participants), function(person) {
    return [_c('span', {
      staticClass: "image is-32x32 sui-avatar sui-avatar--flow"
    }, [_c('img', {
      attrs: {
        "src": person.avatarUrl
      }
    })])]
  })], 2)])])])]), _vm._v(" "), _c('button', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "box has-text-centered"
  }, [_vm._v("\n              No messages\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    attrs: {
      "id": "sui-messages-bottom"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-medium is-white"
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-send"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-9cdc1030"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChatRoom.vue
// module id = 291
// module chunks = 1